import type { Paramsv1WxopenCustomerDetailGet } from '@api/mk-material-center/services/api/WxminiCustomerApi';
import WxminiCustomerApi from '@api/mk-material-center/services/api/WxminiCustomerApi';
import type { Paramsv1TagCusRuleGet } from '@api/mk-tag-svc/services/api/RuleApi';
import RuleApi from '@api/mk-tag-svc/services/api/RuleApi';
import EnterpriseInfoApi from '@/api/mk-account-svc/services/api/EnterpriseInfoApi';
import { SaleShareRecordPost } from '@/h5/reportApi';
import { isBindMiniProgram } from '@cfx/iutils';
import { webGateway } from '@ajax';

// 获取规则详情
export const reqRulesInfo = async (params: Paramsv1TagCusRuleGet) => {
  const res: any = await RuleApi.v1TagCusRuleGet(params);
  if (res.code === 500200 && res.success) return res.data.rules || [];

  throw res;
};

/**
 * 小程序访问素材时，判断是否绑定手机号
 */
export const reqGetPhone = async (params: Paramsv1WxopenCustomerDetailGet) => {
  const res: any = await WxminiCustomerApi.v1WxopenCustomerDetailGet(params);
  if (res.success && res.code === 500200) {
    return {
      isBindPhone: res.data.exist,
      mobile: res.data.mobiles || []
    };
  }
  throw res;
};

// 上报
export const reqSaleShareRecordPost = async (params: any) => {
  const res = await SaleShareRecordPost(params);
  return res;
};

// 获取绑定小程序信息，用于判断是否绑定小程序
export const getBindMiniAppId = async () => {
  const { isBind = false, appId } = await isBindMiniProgram({
    webGateway,
    service: { data: { subDomain: 'bizWxCardMini' }, extra: {} }
  });
  return isBind ? appId : '';
};

// 获取企业信息
export const getCompanyInfo = async (corpId: string) => {
  if (!corpId) return;
  const { success, data } = await EnterpriseInfoApi.v1EnterpriseInfoGet({ corpId });
  if (success) return data;

  throw data;
};
